import React, { Fragment } from "react";
import styled from "styled-components";
import { graphql, useQuery } from "react-apollo";
import { compose } from "recompose";
import friendlyUrl from "speakingurl";
import newQuery from "./graphql/newQuery";
import tagAlbumsQuery from "./graphql/tagAlbumsQuery";
import { View, Text, SlideImage, Link } from "./components";
import Overview from "./components/Overview";
import categoriesProjects from "./categoriesProjects";
import professions from "./professions";
import KeyHandler, { KEYPRESS } from "react-key-handler";
import { useToggle } from "react-hooks-lib";
import Spinner from "./components/Spinner";
import { get } from "./helpers";

const Container = styled(View)`
  min-height: 100vmin;
`;

const getNewOrder = (slide) => {
  const keyValue = slide.slideKeyValues.find(
    (key) => key.slideKey.name === "new-order"
  );
  return keyValue ? keyValue.value : 0;
};

const getArtistProfessionsByArtistName = (artistName, data) => {
  const albums =
    data && "allTags" in data
      ? data.allTags.length > 0 && data.allTags[0]?.albums
      : null;
  if (!albums) return null;

  const bioAlbum = albums.find((album) =>
    album.title.toLowerCase().includes(artistName.toLowerCase())
  );
  if (!bioAlbum) return null;

  const profession = professions.find((profession) => {
    return (
      bioAlbum.tags.find((tag) => tag.name === profession) &&
      !bioAlbum.tags.find((tag) => tag.name === "Talent")
    );
  });
  console.log(profession);
  return profession;
};

const New = ({ data }) => {
  const slides = data.allSlideTags && data.allSlideTags[0]?.slides;
  const { on: editMode, toggle, reset } = useToggle(false);

  const { data: bioData } = useQuery(tagAlbumsQuery, {
    fetchPolicy: "cache-and-network",
    variables: { user: process.env.REACT_APP_WHITESPACE_USER, tagName: "Bio" },
  });

  // query to figure out what the profession of the 'with' artist is:
  /*
  graphql(tagAlbumsQuery, {
    options: () => {
      return {
        fetchPolicy: "cache-first",
        variables: {
          user: process.env.REACT_APP_WHITESPACE_USER,
          tagName: "Bio"
        }
      }
    }
  })
  */
  //

  return (
    <Container>
      <KeyHandler keyEventName={KEYPRESS} keyValue="e" onKeyHandle={toggle} />
      {slides ? (
        <Overview
          onLinkClick={
            editMode
              ? (e, editLink) => {
                  e.preventDefault();
                  window.open(editLink);
                }
              : null
          }
          slides={slides
            .map((slide) => {
              const artistName = findArtistName(
                slide.album.title,
                slide.album.tags
              );
              let withArtist = get(
                slide.album.keyValues.find(
                  (keyValue) => keyValue.key.name === "with"
                ),
                "value"
              );
              let artistNames = findArtistNames(
                slide.album.title,
                slide.album.tags
              );

              let artistProfessions = [];

              if (withArtist && withArtist.length > 0) {
                artistNames = [...artistNames, ...withArtist.split(" / ")];
                artistProfessions = withArtist
                  .split(" / ")
                  .map((artistName) =>
                    getArtistProfessionsByArtistName(artistName, bioData)
                  );
              }
              console.log({ artistProfessions });

              const customTitle = get(
                slide.album.keyValues.find(
                  (keyValue) => keyValue.key.name === "title"
                ),
                "value"
              );

              const realTitle =
                artistName &&
                findAlbumName(
                  slide.album.title.toLowerCase(),
                  artistName.toLowerCase()
                );
              const albumTitle = customTitle || realTitle;

              const albumCategory = findAlbumCategory(slide.album.tags);
              const albumProfession = findAlbumProfession(slide.album.tags);
              const to = `/artist/${friendlyUrl(artistName, {
                lang: "en",
              })}/${friendlyUrl(albumCategory)}/${friendlyUrl(realTitle)}`;
              const artistLink = `/artist/${friendlyUrl(artistName)}`;
              const artistLinks = artistNames.map(
                (artist) => `/artist/${friendlyUrl(artist)}`
              );
              const editLink = `https://whitespace.app/album/${slide.album.id}/slide/${slide.id}`;
              const artist = artistNames
                .join(" / ")
                .split("Volkers")
                .join("Völkers");
              const artists = artistNames.map((artist) =>
                artist.split("Volkers").join("Völkers")
              );
              const profession = albumProfession;
              const order =
                slide.slideKeyValues.length > 0
                  ? parseInt(slide.slideKeyValues[0].value, 10)
                  : 999;
              return {
                ...slide,
                to,
                artistLink,
                artistLinks,
                editLink,
                artist,
                artists,
                profession,
                artistProfessions,
                albumTitle,
                order,
              };
            })
            .sort((a, b) => getNewOrder(b) - getNewOrder(a))}
        />
      ) : (
        <Fragment>
          <View style={{ height: "5vh" }} />
          <Spinner />
        </Fragment>
      )}
    </Container>
  );
};

// new item links to artist/chris-voelkers/untitled
// slug: chris-voelkers-untitled

const findArtistName = (title, tags) => {
  const titleIncludesTag = tags.find((tag) => {
    // console.log(friendlyUrl(tag.name))
    return (
      // artist.title.split("Volkers").join("Völkers").split(" - ")[0]
      title
        .split("Volkers")
        .join("Völkers")
        .toLowerCase()
        .indexOf(tag.name.split("Volkers").join("Völkers").toLowerCase()) >
        -1 && !categoriesProjects.includes(tag.name)
    );
  });
  return titleIncludesTag && titleIncludesTag.name;
};

const findArtistNames = (title, tags) => {
  return tags.reduce((collect, tag) => {
    if (
      // title.indexOf(tag.name) > -1 &&
      !categoriesProjects.includes(tag.name) &&
      !professions.includes(tag.name)
    ) {
      return [...collect, tag.name];
    }
    return collect;
  }, []);
};

const findAlbumName = (title, artistName) => {
  console.log("lalalalala", { title, artistName });
  return title
    .split("völkers")
    .join("volkers")
    .split(artistName + " - ")[1];
};

const findAlbumCategory = (tags) => {
  const tag = tags.find((tag) => {
    // console.log(friendlyUrl(tag.name))
    return categoriesProjects.includes(tag.name);
  });
  const category = tag && tag.name;
  return category;
};

const findAlbumProfession = (tags) => {
  const tag = tags.find((tag) => {
    // console.log(friendlyUrl(tag.name))
    return professions.includes(tag.name);
  });
  const profession = tag && tag.name;
  return profession;
};

export default compose(
  graphql(newQuery, {
    options: () => {
      return {
        fetchPolicy: "cache-and-network",
        variables: {
          user: process.env.REACT_APP_WHITESPACE_USER,
        },
      };
    },
  })
)(New);
